/* unplugin-vue-components disabled */import script from "./AccountPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AccountPanel.vue?vue&type=style&index=0&id=1d6a33a9&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6a33a9"]])

export default __exports__